import {
  Avatar,
  Box,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { SectionPaper } from "../SectionPaper";
import BestQualificationsRadialBar from "../Charts/BestQualificationsRadialBar";
import { useDispatch, useSelector } from "react-redux";
import { getMostCommonQualifications } from "../../Slices/competencePaths";
import { useTheme } from "@mui/material/styles";


// const colors = ["#6DA34D", "#56445D", "#548687", "#8FBC94", "#C5E99B"];

const colors = [
  "#47752F",
  "#56445D",
  "#3E696A",
  "#527A57",
  "#5F7938",
];

const MostCommonQualifications = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const qualifications = useSelector(
    (state) => state.competencePahts.mostCommonQualifications
  );

  useEffect(() => {
    dispatch(getMostCommonQualifications());
  }, [dispatch]);

  return (
    <SectionPaper
      elevation={0}
      overflow="visible"
    >
      <Grid
        container
        spacing={0}
        sx={{
          height: "100%",
        }}
      >
        <Grid item xs={12}>
          <Typography
            component="h2"
            variant="h6"
            align="center"
            color="text.primary"
            sx={{
              pt: 2.5,
              pb: 1,

              fontWeight: 700,
              letterSpacing: "0.01em",

              color: theme.palette.texts.text1,

              textShadow: "0 1px 1px rgba(255,255,255,0.6)",
            }}
          >
            Najczęściej wybierane kwalifikacje
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <List
            disablePadding
            sx={{
              px: { xs: 1, sm: 2 },
              py: 1,
            }}
          >
            {Array.isArray(qualifications) &&
              qualifications?.map((qualification, i) => (
                <ListItem
                  key={qualification.id ?? qualification.name}
                  disableGutters
                  sx={{
                    px: 1.25,
                    py: 1,

                    borderRadius: 2,

                    transition:
                      "background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease",

                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                      transform: "translateX(4px)",
                      boxShadow: "0 3px 10px rgba(41, 78, 107, 0.08)",
                    },
                  }}
                >
                  <ListItemAvatar
                    sx={{
                      minWidth: 52,
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 40,
                        height: 40,

                        bgcolor: colors[i % colors.length],
                        color: "#fff",

                        fontSize: "0.78rem",
                        fontWeight: 700,

                        boxShadow:
                          "0 3px 10px rgba(41, 78, 107, 0.16)",

                        border:
                          "2px solid rgba(255,255,255,0.65)",

                        transition:
                          "transform 0.2s ease, box-shadow 0.2s ease",

                        ".MuiListItem-root:hover &": {
                          transform: "scale(1.08)",
                          boxShadow:
                            "0 5px 14px rgba(41, 78, 107, 0.22)",
                        },
                      }}
                    >
                      {qualification.name
                        .toUpperCase()
                        .split(" ")
                        .map((w) => w[0])
                        .slice(0, 3)
                        .join("")}
                    </Avatar>
                  </ListItemAvatar>

                  <ListItemText
                    primary={qualification.name}
                    primaryTypographyProps={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: theme.palette.texts.text1,
                      lineHeight: 1.35,
                    }}
                  />
                </ListItem>
              ))}
          </List>
        </Grid>

        <Grid
          item
          xs={12}
          height="250px"
          sx={{
            flex: 1,
            minHeight: 200,

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            px: { xs: 1, sm: 2 },
            pb: 2,
            mt: 4,
          }}
        >
          <BestQualificationsRadialBar
            qualifications={Array.isArray(qualifications) ? qualifications : []}
            colors={colors}
          />
        </Grid>
      </Grid>
    </SectionPaper>
  );
};

export default MostCommonQualifications;
